import { Typography, Paper } from '@mui/material'
import { useTranslation } from 'react-i18next'
import CheckDetailTitle from './CheckDetailTitle'
import TimelineDotLine from '../components/TimelineDotLine'
import CheckRiskStatus from '../components/CheckRiskStatus'
import './checks.scss'

const CheckDomains = ({ domainCheck, level = 0 }) => {
  const { t } = useTranslation(['common', 'messages'])

  const domains = domainCheck?.checkDetails?.domainsItems ?? []
  const hasChecks = Array.isArray(domains) && domains.length > 0

  return (
    <>
      <Paper elevation={0} variant="colorPrimary" sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography>{`Website ${t('common:data')}`}</Typography>
        <CheckRiskStatus checkLength={domains.length} hasChecks={hasChecks} />
      </Paper>

      <CheckDetailTitle
        email={domainCheck?.email}
        status={domainCheck?.status}
        createdAt={domainCheck?.createdAt}
        updatedAt={domainCheck?.updatedAt}
      />

      {hasChecks &&
        domains.map((detail, index) => (
          <TimelineDotLine key={index}>
            <Paper variant="rootOutlined" elevation={0} sx={{ flex: 1 }}>
              <div className="c-detail-grid">
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:domain')}</Typography>
                  <Typography variant="subtitle3">{detail.FinalDomainName ?? '---'}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:class')}</Typography>
                  <Typography variant="subtitle3">{detail.DomainClass ?? '---'}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:mainSegment')}</Typography>
                  <Typography variant="subtitle3">{detail.DomainMainSegment ?? '---'}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:visitorRange')}</Typography>
                  <Typography variant="subtitle3">{detail.VisitorRange ?? '---'}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:socialNetworks')}</Typography>
                  <Typography variant="subtitle3">
                    {detail.SocialNetworks ? detail.SocialNetworks?.split(';')?.join(', ') : '---'}
                  </Typography>
                </div>
              </div>
            </Paper>
          </TimelineDotLine>
        ))}

      {domainCheck?.checkDetails?.informação && (
        <Paper variant="rootOutlined" elevation={0} sx={{ mt: 2 }}>
          <div className="c-detail-row">
            <Typography variant="subtitle1">{t('common:information')}</Typography>
            <Typography variant="subtitle3">{domainCheck.checkDetails.informação}</Typography>
          </div>
        </Paper>
      )}
    </>
  )
}

export default CheckDomains
